module.exports = __webpack_public_path__ + "static/securitycompass-logo-b7b1f2131fb084b7bd95442743f8ea3a.png";